// src/components/About.jsx
import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const GlobalAboutCSS = () => (
  <style>{`
    :root{
      --text: #0f172a;
      --muted: rgba(15,23,42,.72);
      --accent: #06b6d4;  /* cyan */
      --accent2:#2563eb;  /* blue */
      --ring: rgba(6,182,212,.35);
      --border: rgba(255,255,255,.22);
      --shadow: 0 18px 50px rgba(2,6,23,.18);
    }

    html, body, #root{ height:100%; }
    body{
      margin:0;
      color:var(--text);
      font-family: Inter, ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Arial;
    }

    /* ✅ Fondo con carrusel full */
    .page-root{
      position: relative;
      min-height: 100vh;
      overflow: hidden;
    }

    .bg-slider{
      position: absolute;
      inset: 0;
      z-index: 0;
    }

    .bg-slider .slick-slider,
    .bg-slider .slick-list,
    .bg-slider .slick-track,
    .bg-slider .slick-slide > div{
      height: 100vh;
    }

    .bg-slide{
      position: relative;
      width: 100%;
      height: 100vh;
    }

    .bg-img{
      width:100%;
      height:100%;
      object-fit:cover;
      transform: scale(1.04);
      filter: saturate(1.05) contrast(1.02);
    }

    .bg-overlay{
      position:absolute;
      inset:0;
      background:
        radial-gradient(900px 600px at 12% 10%, rgba(37,99,235,.25), transparent 55%),
        radial-gradient(900px 600px at 88% 12%, rgba(6,182,212,.28), transparent 50%),
        radial-gradient(900px 600px at 30% 90%, rgba(99,102,241,.18), transparent 55%),
        linear-gradient(180deg, rgba(0,0,0,.35), rgba(0,0,0,.55));
    }

    /* ✅ Contenido encima (centrado) */
    .page-content{
      position: relative;
      z-index: 2;
      min-height: 100vh;
      display: grid;
      align-items: center;
      padding: clamp(18px, 4vw, 36px);
    }

    .wrap{
      width: min(1180px, 92vw);
      margin: 0 auto;
    }

    /* ✅ Glass card (igual que Home) */
    .card{
      background: rgba(255,255,255,.14);
      border: 1px solid var(--border);
      border-radius: 22px;
      box-shadow: var(--shadow);
      backdrop-filter: blur(14px);
      -webkit-backdrop-filter: blur(14px);
      padding: clamp(16px, 3.2vw, 28px);
      color: #fff;
    }

    .topNav{
      display:flex;
      justify-content: space-between;
      align-items:center;
      gap: 10px;
      margin-bottom: 14px;
      flex-wrap: wrap;
    }

    .brandMini{
      display:flex;
      align-items:center;
      gap: 10px;
      color: rgba(255,255,255,.85);
      font-weight: 900;
    }

    .logoMini{
      width: 34px;
      height: 34px;
      border-radius: 12px;
      background: rgba(255,255,255,.18);
      border: 1px solid rgba(255,255,255,.22);
      display:flex;
      align-items:center;
      justify-content:center;
      overflow:hidden;
      flex: 0 0 auto;
    }
    .logoMini img{ width:100%; height:100%; object-fit:cover; }

    .title{
      margin: 0 0 12px;
      font-size: clamp(22px, 3.2vw, 36px);
      font-weight: 900;
      letter-spacing: .2px;
      line-height: 1.05;
    }

    .title span{
      background: linear-gradient(90deg, var(--accent2), var(--accent));
      -webkit-background-clip: text;
      background-clip:text;
      color: transparent;
    }

    .lead{
      margin: 0;
      font-size: clamp(14px, 1.45vw, 17px);
      line-height: 1.85;
      color: rgba(255,255,255,.86);
      max-width: 80ch;
      text-align: justify;
    }
    .lead + .lead{ margin-top: 12px; }

    /* Botones iguales que Home */
    .btn{
      cursor:pointer;
      border: 0;
      border-radius: 14px;
      padding: 12px 14px;
      font-weight: 900;
      transition: transform .12s ease, filter .2s ease;
      display:inline-flex;
      align-items:center;
      gap: 10px;
      user-select: none;
      white-space: nowrap;
    }
    .btn:active{ transform: translateY(1px); }
    .btn-primary{
      background: linear-gradient(180deg, rgba(6,182,212,1), rgba(37,99,235,1));
      color:#062028;
      box-shadow: 0 12px 30px rgba(6,182,212,.18);
    }
    .btn-ghost{
      background: rgba(255,255,255,.14);
      color:#fff;
      border: 1px solid rgba(255,255,255,.22);
    }
    .btn:hover{ filter: brightness(1.05); }

    /* Slick dots/arrows */
    .bg-slider .slick-dots{
      bottom: 18px;
      z-index: 6;
    }
    .bg-slider .slick-dots li button:before{
      color: rgba(255,255,255,.55);
      opacity: 1;
      font-size: 10px;
    }
    .bg-slider .slick-dots li.slick-active button:before{
      color: rgba(6,182,212,1);
    }
    .bg-slider .slick-prev, .bg-slider .slick-next{
      z-index: 7;
      width: 44px;
      height: 44px;
      border-radius: 999px;
      background: rgba(255,255,255,.16);
      border: 1px solid rgba(255,255,255,.22);
      backdrop-filter: blur(12px);
      -webkit-backdrop-filter: blur(12px);
    }
    .bg-slider .slick-prev{ left: 16px; }
    .bg-slider .slick-next{ right: 16px; }
    .bg-slider .slick-prev:before, .bg-slider .slick-next:before{
      color: rgba(255,255,255,.9);
      opacity: 1;
      font-size: 20px;
    }

    .hint{
      margin-top: 12px;
      font-size: 12px;
      color: rgba(255,255,255,.70);
    }
  `}</style>
);

export default function About() {
  const navigate = useNavigate();

  const slides = useMemo(
    () => [
      {
        src: "https://images.unsplash.com/photo-1477959858617-67f85cf4f1df?fm=jpg&q=60&w=2400&ixlib=rb-4.0.3",
        alt: "Publicidad en vehículos",
      },
      {
        src: "https://media.istockphoto.com/id/612630478/photo/hong-kong-night-scene.jpg?s=2048x2048",
        alt: "Ciudad nocturna",
      },
      {
        src: "https://www.odedwagen.com/wp-content/uploads/revslider/sliderpreview_fullscreen/photodune-1717995-los-angeles-urban-city-at-sunset-with-freeway-trafic-m.jpg",
        alt: "Tráfico urbano al atardecer",
      },
    ],
    []
  );

  const settings = useMemo(
    () => ({
      dots: true,
      infinite: true,
      speed: 700,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 4200,
      arrows: true,
      pauseOnHover: false,
      pauseOnFocus: false,
    }),
    []
  );

  return (
    <>
      <GlobalAboutCSS />

      <div className="page-root">
        {/* Fondo con carrusel */}
        <div className="bg-slider" aria-hidden="true">
          <Slider {...settings}>
            {slides.map((s, i) => (
              <div key={i}>
                <div className="bg-slide">
                  <img className="bg-img" src={s.src} alt={s.alt || "Slide"} />
                  <div className="bg-overlay" />
                </div>
              </div>
            ))}
          </Slider>
        </div>

        {/* Contenido */}
        <div className="page-content">
          <div className="wrap">
            <div className="card">
              <div className="topNav">
                <button className="btn btn-ghost" onClick={() => navigate("/")}>
                  ← Volver
                </button>

                <div className="brandMini">
                  <span className="logoMini">
                    <img src="/screen-do-logo.png" alt="Screen DO" />
                  </span>
                  Screen DO
                </div>

                <button className="btn btn-primary" onClick={() => navigate("/contact")}>
                  📩 Contacto
                </button>
              </div>

              <h2 className="title">
                Quiénes <span>Somos</span>
              </h2>

              <p className="lead">
                En <strong>Screen DO</strong> somos líderes en publicidad dinámica en vehículos, ofreciendo soluciones
                innovadoras y de alto impacto visual que permiten a las marcas conectar con su público de manera directa,
                moderna y efectiva. A través de pantallas publicitarias inteligentes y no invasivas, llevamos tu mensaje
                a las calles y lo posicionamos en puntos de alto tráfico, aumentando el alcance, la visibilidad y el
                reconocimiento de marca en tiempo real.
              </p>

              <p className="lead">
                Al mismo tiempo, <strong>Screen DO</strong> representa una oportunidad real para los conductores de
                plataformas de transporte. Si conduces a diario, puedes generar ingresos adicionales de forma inteligente
                y sin afectar tu trabajo, simplemente instalando nuestras pantallas en tu vehículo. Mientras realizas tus
                rutas habituales, la pantalla trabaja por ti, sin interrupciones ni molestias para tus pasajeros.
              </p>

              <p className="lead">
                Con <strong>Screen DO</strong>, las marcas crecen, los conductores ganan más y la publicidad evoluciona
                hacia un modelo más eficiente, tecnológico y rentable para todos.
              </p>

              <div className="hint">
                ¿Listo para comenzar? Entra a <strong>Acceso Socio</strong> desde la página principal.
              </div>
            </div>

            {/* espacio extra para que en mobile no tape los dots */}
            <div style={{ height: 24 }} />
          </div>
        </div>
      </div>
    </>
  );
}
